import styles from "@/components/greeting.module.css";
import * as signals from "@/signals";
import { useSignalEffect } from "@preact/signals";
import clsx from "clsx";
import { JSX, useCallback, useState } from "react";

function Greeting(): JSX.Element {
	const [isClosing, setIsClosing] = useState<boolean>(false);

	const closeGreeting = useCallback(() => {
		setIsClosing(true);
		window.setTimeout(() => {
			setIsClosing(false);
			signals.greetingText.value = "";
		}, 500);
	}, []);

	useSignalEffect(() => {
		if (!signals.greetingText.value) {
			return;
		}
		const timeoutId = window.setTimeout(() => {
			closeGreeting();
		}, 3000);
		return (): void => {
			window.clearTimeout(timeoutId);
		};
	});

	if (!signals.greetingText.value) {
		return <></>;
	}
	return (
		<div
			className={clsx(
				styles["greeting-wrapper"],
				!isClosing && styles["slide-in"],
				isClosing && styles["slide-out"],
				"z-index", // above popup
			)}
		>
			<div className={styles["greeting"]}>
				{signals.greetingText.value}
			</div>
		</div>
	);
}

export default Greeting;
